import React from 'react'
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/js/bootstrap.bundle"
import './css/trending.css'
import { ChevronsRight} from "lucide-react";
export default function Trending() {
  return (<>
    <div className='header-containerr'>
    <header className='header-name'>
        <h1>Breaking News</h1>
        <div>
          <ChevronsRight color="black" size={24} />
        </div>
    </header>
    </div>
    <section className="py-5 bg-light">
  <div className="container">
    {/* <h2 className="text-center mb-4 fs-4 fw-bold font-serif">Trending</h2> */}
    <div className="row g-4">
      {/* Article 1 */}
      <div className="col-12 col-md-6 col-lg-3">
        <div className="text-center">
          <span className="display-1 fw-normal text-muted">01</span>
          <a href="#" className='anchor'>
          <h3 className="fs-5 mt-3 fw-bold text-dark">
            Paris Fashion Week: The Most Talked-About Shows
          </h3>
          <p className="text-muted small">
            From groundbreaking collections to surprise runway moments...
          </p>
          </a>
        </div>
      </div>
      {/* Article 2 */}
      <div className="col-12 col-md-6 col-lg-3">
        <div className="text-center">
          <span className="display-1 fw-normal text-muted">02</span>
          <a href="#" className='anchor'>
          <h3 className="fs-5 mt-3 fw-bold text-dark">
            The Rise of Sustainable Luxury: A New Era
          </h3>
          <p className="text-muted small">
            How high-end brands are embracing eco-conscious fashion...
          </p>
          </a>
        </div>
      </div>
      {/* Article 3 */}
      <div className="col-12 col-md-6 col-lg-3">
        <div className="text-center">
          <span className="display-1 fw-normal text-muted">03</span>
          <a href="#" className='anchor'>
          <h3 className="fs-5 mt-3 fw-bold text-dark">
            Celebrity Style Watch: Red Carpet Revolution
          </h3>
          <p className="text-muted small">
            Breaking down the most influential celebrity fashion moments...
          </p>
          </a>
        </div>
      </div>
      {/* Article 4 */}
      <div className="col-12 col-md-6 col-lg-3">
        <div className="text-center">
          <span className="display-1 fw-normal text-muted">04</span>
          <a href="#" className='anchor'>
          <h3 className="fs-5 mt-3 fw-bold text-dark">
            Beauty Trends That Will Define Spring 2024
          </h3>
          <p className="text-muted small">
            The most innovative beauty looks from industry experts...
          </p>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

</>

  )
}
